import type { Dispatch } from "@reduxjs/toolkit";
import {
  setCurrentWorkSpace,
  setOwner,
  setUser,
} from "../store/slices/ownerSlice";
import { setStoredOwner, setStoredUser } from "./authStorage";

export type SigninResult = {
  success?: boolean;
  email?: string;
  firstName?: string;
  lastName?: string;
  userId?: string;
  owner?: Record<string, unknown> | null;
  userBilling?: Record<string, unknown> | null;
  currentWorkSpace?: Record<string, unknown> | null;
};

/** Persist sign-in response to localStorage and Redux (same shape as Login page). */
export function applySigninSession(
  result: SigninResult,
  dispatch: Dispatch,
  fallbackEmail?: string
): boolean {
  if (!result?.success) return false;

  const userEmail = String(result.email || fallbackEmail || "").trim();
  const userFirstName = String(result.firstName || "").trim();
  const userLastName = String(result.lastName || "").trim();
  const resolvedUserId = String(result.userId || "").trim();

  const userBilling = result.userBilling;

  const sessionUser = {
    userId: resolvedUserId,
    email: userEmail,
    ...(userFirstName ? { firstName: userFirstName } : {}),
    ...(userLastName ? { lastName: userLastName } : {}),
    userBilling: userBilling || null,
  };
  setStoredUser(sessionUser);
  dispatch(setUser(sessionUser));

  const sessionOwner =
    result.owner ||
    ({
      email: result.email || fallbackEmail,
      userId: result.userId,
      firstName: result.firstName || "",
      lastName: result.lastName || "",
      name: `${result.firstName || ""} ${result.lastName || ""}`.trim(),
      linkedOwners: [],
      planhistory: Array.isArray(userBilling?.planhistory)
        ? (userBilling?.planhistory ?? [])
        : [],
      stripeCustomerId: userBilling?.stripeCustomerId || "",
      PaymentTries: Number(userBilling?.PaymentTries || 0),
      stripePaymentFailure: userBilling?.stripePaymentFailure || null,
      workspaces: [],
    } as Record<string, unknown>);

  setStoredOwner(sessionOwner);
  dispatch(setOwner(sessionOwner as any));
  if (result.currentWorkSpace) {
    dispatch(setCurrentWorkSpace(result.currentWorkSpace as any));
  }
  return true;
}
